import { useEffect, useState } from 'react';
import { App } from 'antd';

const useMockPlaidLink = ({ onSuccess, onExit, onEvent, token }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { modal } = App.useApp();

  const ready = token != null;

  useEffect(() => {
    setIsModalVisible(ready);
  }, [ready]);

  const open = () => {
    isModalVisible &&
      modal.confirm({
        title: 'Simulated Plaid Link',
        content: (
          <div>
            <p>Simulating Plaid Link connection...</p>
            <p>Select your bank to continue.</p>
          </div>
        ),
        onOk: () => {
          setIsModalVisible(false);
          const mockPublicToken = 'mock-public-token-for-' + token;
          const mockMetadata = {
            account: {
              id: 'mock-account-id',
              name: 'Mock Bank Account',
            },
          };

          if (onSuccess) {
            onSuccess(mockPublicToken, mockMetadata);
          }

          if (onEvent) {
            onEvent('mock-event', { message: 'Simulated Plaid Link opened' });
          }
        },
        onCancel: () => {
          setIsModalVisible(false);
          if (onExit) {
            onExit('User canceled the mock flow', { message: 'User exited' });
          }
        },
      });
  };

  return { open, exit: () => {}, ready };
};

export { useMockPlaidLink };
